<div class="fulfill-side-panel-order" [ngClass]="{ open: isShown, zoom: isPickAndPackFocus }">
  <div class="fulfill-side-panel-order__header">
    <fulfill-side-panel-order-header
      [order]="fulfillService.activeOrder$ | async"
      [isPickAndPackFocus]="isPickAndPackFocus"
      [printOptions]="printOptions"
      [printSections]="printSections"
      (printOrder)="printOrder($event)"></fulfill-side-panel-order-header>
  </div>
  <div class="fulfill-side-panel-order__main">
    @if (!isPickAndPackFocus) {
      <fulfill-side-panel-order-info
        class="info"
        [printOptions]="printOptions"
        [printSections]="printSections"
        [order]="fulfillService.activeOrder$ | async"
        (printOrder)="printOrder($event)"></fulfill-side-panel-order-info>
    }
    <fulfill-side-panel-order-items
      class="items"
      [order]="fulfillService.activeOrder$ | async"
      [isPickAndPackFocus]="isPickAndPackFocus"></fulfill-side-panel-order-items>
  </div>
  <div class="fulfill-side-panel-order__footer">
    <fulfill-side-panel-order-footer [shop]="order.shop"></fulfill-side-panel-order-footer>
  </div>
</div>
